import { render, staticRenderFns } from "./AssignBooth.vue?vue&type=template&id=56589b45&scoped=true"
import script from "./AssignBooth.vue?vue&type=script&lang=ts"
export * from "./AssignBooth.vue?vue&type=script&lang=ts"
import style0 from "./AssignBooth.vue?vue&type=style&index=0&id=56589b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56589b45",
  null
  
)

export default component.exports